import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VModal from 'vue-js-modal'
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import VTooltip from 'v-tooltip'
import pl from "./lang/pl.json"
import de from "./lang/de.json"
import en from "./lang/en.json"
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./filters"
import Vuebar from 'vuebar';
import axios from 'axios';
import SocialSharing from 'vue-social-sharing'
import store from './store/index'

Vue.use(SocialSharing);
Vue.use(Vuebar);
Vue.use(VModal)
Vue.use(BootstrapVue);
Vue.use(VueI18Next);
Vue.use(VTooltip);
Vue.config.productionTip = false
// Vue.config.performance = true
i18next.init({
    lng: 'pl',
    resources: {
        pl: { translation: pl },
        de: { translation: de },
        en: { translation: en },
    }
});
const i18n = new VueI18Next(i18next);

axios.interceptors.request.use((config) => {
    if (config.url.includes("https://"))
        return config;
    config.url = `${process.env.VUE_APP_API_URL}${config.url}`;
    return config;
});

Vue.prototype.$http = axios;

Vue.mixin({
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
})

window.vm = new Vue({
    render: h => h(App),
    i18n: i18n,
    store,
}).$mount('#app')